// extracted by mini-css-extract-plugin
export default {"twoColumnsContainer":"TwoColumns_twoColumnsContainer__O73EV","leftColumn":"TwoColumns_leftColumn__N77zx","rightColumn":"TwoColumns_rightColumn__+DXW9"};